export const lockUserConstant = Object.freeze({
  LOCK_DESCRIPTION_CHARACTER_LIMIT: 500,
});
